import React from "react";
import cateringIcon from "../../assets/icons/catering-alt-dark.svg";
import luggageIcon from "../../assets/icons/luggage-dark.svg";
import toiletIcon from "../../assets/icons/toilet-dark.svg";
import wifiIcon from "../../assets/icons/wifi-dark.svg";
import ownerApprovalIcon from "../../assets/icons/owner-approval-dark.svg";
import starDarkIcon from "../../assets/icons/star-dark.svg";

/**
 * Renders the aircraft details column: name, summary, specs grid, and flight details toggle.
 */
const AircraftCardDetails = ({
    aircraftName,
    recommended,
    category,
    floatingFleet,
    yom,
    refurbishedYear,
    seats,
    luggage,
    cateringOption,
    toilet,
    ownerApproval,
    wifiOption,
    tailNumber,
}) => (
    <div className="aircraft-card__details-column">
        <div className="aircraft-card__header-row">
            <div className="aircraft-card__aircraft-name--text">{aircraftName}</div>
            {recommended && (
                <div className="aircraft-card__recommendation">
                    <img src={starDarkIcon} alt="" className="aircraft-card__recommendation-star" />
                    <span>SHY RECOMMENDS</span>
                </div>
            )}
        </div>
        <div className="aircraft-card__text-block">
            <p className="aircraft-card__summary-line">
                <span className="aircraft-card__summary-label aircraft-card__summary-label--bold">
                    {category || "-"}
                </span>
                {floatingFleet && (
                    <span>
                        , *<strong>Floating Fleet</strong>
                    </span>
                )}
            </p>
            <p className="aircraft-card__summary-line">
                <span className="aircraft-card__summary-label">Manufactured:</span> {yom || "-"}
                {refurbishedYear && refurbishedYear !== "" && (
                    <>
                        {" "}
                        <span className="aircraft-card__summary-label">Refurbished:</span> {refurbishedYear}
                    </>
                )}
            </p>
            <p className="aircraft-card__summary-line">
                <span className="aircraft-card__summary-label">Seating capacity:</span>&nbsp;
                {seats ? (
                    <>
                        Up to {seats} passenger{seats === 1 ? "" : "s"}
                    </>
                ) : (
                    "-"
                )}
            </p>
        </div>

        <div className="aircraft-card__spec-grid">
            <div className="aircraft-card__spec">
                <img src={luggageIcon} alt="" />
                <div className="aircraft-card__spec-text">
                    <span className="aircraft-card__spec-label">Luggage:</span>{" "}
                    {typeof luggage !== "undefined" && luggage !== null
                        ? `${luggage} bag${luggage === 1 ? "" : "s"} (Max 20kg each)`
                        : "-"}
                </div>
            </div>
            <div className="aircraft-card__spec">
                <img src={cateringIcon} alt="" />
                <div className="aircraft-card__spec-text">
                    <span className="aircraft-card__spec-label">Catering:</span> {cateringOption || "-"}
                </div>
            </div>
            <div className="aircraft-card__spec">
                <img src={toiletIcon} alt="" />
                <div className="aircraft-card__spec-text">
                    <span className="aircraft-card__spec-label">WC:</span> {toilet || "No"}
                </div>
            </div>
            <div className="aircraft-card__spec">
                <img src={ownerApproval === "Y" ? ownerApprovalIcon : wifiIcon} alt="" />
                <div className="aircraft-card__spec-text">
                    {ownerApproval === "Y" ? (
                        <>
                            <span className="aircraft-card__spec-label">Owner approval:</span> Required
                        </>
                    ) : (
                        <>
                            <span className="aircraft-card__spec-label">WiFi:</span> {wifiOption || "-"}
                        </>
                    )}
                </div>
            </div>
        </div>

        {floatingFleet && (
            <p className="aircraft-card__floating-fleet-note">
                <em>
                    * Floating fleet is a supplier with multiple of the same OR similar category of aircraft (Interior
                    and exterior aesthetics are subject to change)
                </em>
            </p>
        )}
    </div>
);

export default AircraftCardDetails;
